
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { namespace } from 'vuex-class'
import exports from "@/store/modules/exports"

const stimulus = namespace('stimulus')

@Component
export default class ExportVideoDialog extends Vue {
  @Prop() private readonly chartOptions!: any

  @stimulus.Getter('getProjectId')
  private projectId!: string

  @stimulus.Getter('getVideoId')
  private videoId!: any

  private headers: any[] = [
    { text: 'Video', align: 'start', value: 'video', sortable: false },
    { text: 'Status', align: 'center', value: 'status', sortable: false },
    { text: 'Delete', align: 'center', value: 'delete', sortable: false }
  ]
  private dialog: boolean = false
  private autoUpdateTimer: any = ''
  private isVideoProcessing: boolean = false
  private newVideoName: string = ''
  private isVideoNameValid: boolean = false
  private errorMessage: string = ''
  private videoNameRules: any = {
    required: (value: string) => !!value || 'Video name is required!',
    alphanumeric: (value: string) => {
      const pattern = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
      return !pattern.test(value) || 'Invalid video name! Special characters not allowed!'
    },
    duplicate: (value: string) => {
      const duplicates = this.exportedVideos.filter(item => item.name === value)
      return !(duplicates.length>0) || 'Video name already exists!'
    }
  }

  $refs!: { form: HTMLFormElement }

  get exportedVideos() {
    return exports.listVideos.sort((a: any, b: any) => (a.uploaded_at < b.uploaded_at) ? 1 : -1)
  }

  get hasError() {
    return this.errorMessage !== ''
  }

  @Watch('dialog')
  public toggle(): void {
    this.dialog ? this.collectExportedVideos() : this.stopAutoUpdate()
    this.clean()
  }

  private async collectExportedVideos() {
    await this.updateExportedVideos()
    this.shouldAutoUpdate() && this.startAutoUpdate()
  }

  private shouldAutoUpdate() {
    return exports.listVideos.filter(item => item.status === 'PROCESSING').length > 0
  }

  private async autoUpdate() {
    await this.updateExportedVideos()
    !this.shouldAutoUpdate() && this.stopAutoUpdate()
  }

  private startAutoUpdate() {
    this.autoUpdateTimer = setInterval(this.autoUpdate, 5000)
    this.isVideoProcessing = true
  }

  private stopAutoUpdate() {
    if (this.autoUpdateTimer === '') { return }
    clearInterval(this.autoUpdateTimer)
    this.isVideoProcessing = false
    this.clean()
  }

  private async createExportedVideo() {
    try {
      await exports.createVideo({
        name: this.newVideoName, stimulus: this.videoId, chart: JSON.stringify(this.chartOptions)
      })
    } catch (err) {
      this.errorMessage = 'An error occured creating a new videos!'
      throw err
    }
  }

   private async deleteExportedVideo(id: string) {
    try {
      await exports.removeVideo(id)
    } catch (err) {
      this.errorMessage = 'An error occured deleting the video!'
      throw err
    }
  }

  private async updateExportedVideos() {
    try {
      await exports.getVideos({ project: this.projectId, stimulus: this.videoId })
    } catch (err) {
      this.errorMessage = 'An error occured listing exported videos!'
      throw err
    }
  }

  public addVideoExtension(name: string): string {
    return name + ".mp4"
  }

  public clean() {
    this.newVideoName = ''
    this.$refs.form && this.$refs.form.reset()
  }

  public remove(item: any) {
    this.exportedVideos.indexOf(item) >- 1 && this.deleteExportedVideo(item.id)
  }
  
  public save() {
    this.createExportedVideo()
    this.startAutoUpdate()
  }
}
